export const types = {
  GETTING_CITIES: 'GETTING_CITIES',
  GET_CITIES_SUCCESS: 'GET_CITIES_SUCCESS',
  GETTING_DISTRICTS: 'GETTING_DISTRICTS',
  GETTING_WARDS: 'GETTING_WARDS',
  GET_ADDRESS_SUCCESS: 'GET_ADDRESS_SUCCESS',
  GET_ADDRESS_FAIL: 'GET_ADDRESS_FAIL',
  CLEAR_ADDRESS: 'CLEAR_ADDRESS',
}
